import { createContextEvent } from '../create-custom-event';

export const DIRTY_FORM_NAVIGATION_ACTION = 'DIRTY_FORM_NAVIGATION_EVENT' as const;
export type PreventDirtyFormNavigationAction = typeof DIRTY_FORM_NAVIGATION_ACTION;

export interface IPreventDirtyFormNavigationAction {
  targetURL: string;
}

export type PreventDirtyFormNavigationEvent = CustomEvent<IPreventDirtyFormNavigationAction>;

export function createDirtyFormGuardEvent(targetURL: string): PreventDirtyFormNavigationEvent {
  return createContextEvent({ eventType: DIRTY_FORM_NAVIGATION_ACTION, eventDetail: { targetURL } });
}
